import React from "react";
import { ServiceHero, SectionTitle, StepList } from "@/components/Bits";
import { RequestForm } from "@/components/RequestForm";
import { useLang } from "@/context/LanguageContext";

export default function Investir() {
  const { t } = useLang();
  const steps = t("svc.inv.steps").map((s) => ({ title: s.t, desc: s.d }));
  return (
    <div className="bg-ivory">
      <ServiceHero eyebrow={t("svc.inv.eyebrow")} title={t("svc.inv.title")} subtitle={t("svc.inv.subtitle")}
        image="https://images.unsplash.com/photo-1758193431355-54df41421657?w=1920&q=85" />
      <section className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-20">
        <SectionTitle eyebrow={t("svc.inv.mEyebrow")} title={t("svc.inv.mTitle")} className="mb-12" />
        <StepList steps={steps} />
      </section>
      <section className="max-w-3xl mx-auto px-4 sm:px-8 lg:px-16 pb-24">
        <SectionTitle center title={t("svc.inv.formTitle")} className="mb-8" />
        <RequestForm type="investissement" testid="invest-form" submitLabel={t("svc.inv.submit")}
          fields={[
            { name: "budget", label: t("svc.inv.fBudget"), placeholder: t("svc.inv.fBudgetPh") },
            { name: "location", label: t("svc.inv.fLoc"), placeholder: t("svc.inv.fLocPh") },
            { name: "subject", label: t("svc.inv.fType"), placeholder: t("svc.inv.fTypePh") },
            { name: "category", label: t("svc.inv.fGoal"), placeholder: t("svc.inv.fGoalPh") },
          ]} />
      </section>
    </div>
  );
}
